<template>
  <div class="training-introduction-component">
    <bottom-bar-layout :show-bar="showBar"
                       :shadow="false"
                       bar-background="transparent"
                       :bar-height="barHeight"
                       :target-id="id"
                       target-type="training"
                       :show-consult="showConsult"
                       :is-show-guide-popup="false"
    >
      <slot></slot>

      <slot name="bottom">

        <div class="training-introduction-about">
          <about :about="about" />
        </div>

        <template #tabbar>
          <bottom-bar :id="id"
                      :type="type"
                      :title="title"
                      :sell="sell"
                      :is-member="isMember"
                      :benefit-bar="benefitBar"
                      :render-price="bottomBar.renderPrice"
                      :action-bar="bottomBar.actionBar"
                      :primary-price="primaryPrice"
                      :my-team-id="myTeamId"
                      :join-btn-round="joinBtnRound"
                      @disabled-join="handleDisabledJoin"
                      @joined="handleJoined"
                      @qr-code="handleShowQrCode"
          />
        </template>
      </slot>
    </bottom-bar-layout>

    <qr-code-popup v-if="memberWxGroupQrCode && memberWxGroupQrCode !== ''"
                   :show.sync="showWxGroupQrCode"
                   title="加入训练营微信群"
                   :src="memberWxGroupQrCode"
                   :hint="hint"
    />
  </div>
</template>

<script>
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import About from '@/pages/Training/components/TrainingDetailAbout';
  import BottomBar from '@/pages/Training/components/TrainingDetailBottomBar';
  import QrCodePopup from '@/components/QrCodePopup';
  import { isAppWebView } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'TrainingIntroduction',
    components: {
      BottomBarLayout,
      About,
      BottomBar,
      QrCodePopup,
    },
    data() {
      return {
        showWxGroupQrCode: false,
        hint: '长按识别进群<br>掌握课程最新信息',
      };
    },
    props: {
      showBar: Boolean,
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      sell: {
        type: Object,
        required: true,
      },
      about: {
        type: String,
        required: true,
      },
      joinStatus: {
        type: String,
        required: true,
      },
      showConsult: Boolean,
      benefitBar: null,
      bottomBar: {
        type: Object,
        required: true,
      },
      primaryPrice: {
        type: Object,
        required: true,
      },
      myTeamId: Number,
      memberWxGroupQrCode: String,
      joinBtnRound: Boolean,
    },
    computed: {
      isMember() {
        return this.joinStatus === 'member';
      },
      barHeight() {
        const { joinBtnRound } = this;
        return joinBtnRound ? 130 : 120;
      },
    },
    methods: {
      handleJoined() {
        this.$emit('joined');
      },
      handleDisabledJoin() {
        this.$emit('disabled-join');
      },
      handleShowQrCode() {
        if (isAppWebView()) {
          locationToAppWithRoute({
            name: 'AppQrCodeDetail',
            params: {
              qrCode: this.memberWxGroupQrCode,
              hint: this.hint,
            },
          });
          return;
        }
        this.showWxGroupQrCode = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-introduction-component {
    height: 100%;
    background: @color-white;
  }

  .training-introduction-about {
    padding-top: @size-small;
    background-color: @background-color-base;
  }
</style>
